module.exports = __webpack_public_path__ + "static/img/shopee.9a776873.png";